
import "./App.css";
import bgimage from './images/bg-intro-desktop.png';
import mobileimage from './images/bg-intro-mobile.png';


function App() {
  
  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

 const submit = (e) => {
    e.preventDefault();
    const firstname = document.getElementById('firstname');
    const lastname = document.getElementById('lastname');
    const email = document.getElementById('email');
    const password = document.getElementById('password');
    const errmsg = document.getElementsByClassName("err-msg");
    const errorIcon = document.getElementsByClassName("errorIcon");
    
      if(firstname.value === ''){
        
        errmsg[0].style.display= "block";
        firstname.style.border = "2px solid hsl(0, 100%, 74%)";
        errorIcon[0].style.display= "flex";
      }else{
        errmsg[0].style.display= "none";
        firstname.style.border = "1px solid hsl(246, 25%, 77%)";
        errorIcon[0].style.display= "none";
      }
      if(lastname.value === ''){
        errmsg[1].style.display= "block";
        lastname.style.border = "2px solid hsl(0, 100%, 74%)";
        errorIcon[1].style.display= "flex";
      }else{
        errmsg[1].style.display= "none";
        lastname.style.border = "1px solid hsl(246, 25%, 77%)";
        errorIcon[1].style.display= "none";
      }
  
      if(email.value === '' || !validateEmail(email.value)){
        errmsg[2].style.display= "block";
        email.style.border = "2px solid hsl(0, 100%, 74%)";
        errorIcon[2].style.display= "flex";
      }else{
        errmsg[2].style.display= "none";
        email.style.border = "1px solid hsl(246, 25%, 77%)";
        errorIcon[2].style.display= "none";
      }
      if(password.value === ''){
        errmsg[3].style.display= "block";
        password.style.border = "2px solid hsl(0, 100%, 74%)";
        errorIcon[3].style.display= "flex";
      }else{
        errmsg[3].style.display= "none";
        password.style.border = "1px solid hsl(246, 25%, 77%)";
        errorIcon[3].style.display= "none";
      }
   
      
 }
  return (
    <div className="main-bg">
      <img src={bgimage} alt='background' id="desktopimg"/>
      <img src={mobileimage} alt='background' id="mobileimg"/>
      <div className="main-content">
        <div className="input-flex">
          <div className="input-text">
            <h2> Learn to code by watching others</h2>
            <div>
              See how experienced developers solve problems in real-time.
              Watching scripted tutorials is great, 
              but understanding how developers think is invaluable.
            </div>
          </div>
          <div className="input-box">
            <div className="try-out">
              Try it free 7 days <span>then $20/mo. thereafter</span>
            </div>
            <form>
              <div className="input">
              <input type='text' placeholder="First Name" id="firstname"/>
                <div className="errorIcon" id="fnIcon">!</div>
                <div id="err-msg" className="err-msg err-hide"> First name cannot be empty</div>
              </div>
              <div className="input">
                <input type='text' placeholder="Last Name" id="lastname"/>
                <div className="errorIcon">!</div>
                <div id="lerr-msg" className="err-msg err-hide"> Last Name cannot be empty</div>
              </div>
              <div className="input">
                <input type='email' placeholder="Email Address" id="email"/>
                <div className="errorIcon">!</div>
                <div id="eerr-msg" className="err-msg err-hide"> Looks like this is not an email</div>
              </div>
              <div className="input">
                <input type='password' placeholder="Password" id="password"/>
                <div className="errorIcon">!</div>
                <div id="perr-msg" className="err-msg err-hide"> Password cannot be empty </div>
              </div>
              <div className="claim" onClick={submit}> 
                Claim Your Free Trial
              </div>
              <p> By clicking the button, you are agreeing to our <a href="/">Terms and Services</a></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
